// Data for IP Protection Office website

export const testimonials = [
  {
    id: 1,
    name: "Rachel Nguyen",
    role: "Founder, Bloom Botanicals",
    content: "IP Protection Office walked me through every stage of filing. Their attention to detail caught potential conflicts I never would have spotted on my own. My brand is now fully protected.",
    rating: 5
  },
  {
    id: 2,
    name: "Derek Lawson",
    role: "CEO, NovaTech Solutions",
    content: "We needed our software brand locked down before launch. The team delivered a thorough search report, filed everything precisely, and kept us updated weekly. Couldn't have asked for more.",
    rating: 5
  },
  {
    id: 3,
    name: "Monica Reyes",
    role: "Owner, Casa Dulce Bakery",
    content: "As a small business owner, I was intimidated by the trademark process. IP Protection Office made it feel effortless. They explained every document in plain English and handled all the paperwork.",
    rating: 5
  },
  {
    id: 4,
    name: "Kevin Bradshaw",
    role: "Managing Partner, Bradshaw & Cole",
    content: "Their legal team is exceptionally sharp. They resolved an office action that another firm failed to address properly. That level of expertise is rare in this price range.",
    rating: 5
  },
  {
    id: 5,
    name: "Priya Kapoor",
    role: "Creative Director, Indigo Press",
    content: "The copyright registration for our publication catalog went smoothly from start to finish. The dedicated case manager was always one step ahead, anticipating exactly what we needed.",
    rating: 5
  },
  {
    id: 6,
    name: "Brandon Ellis",
    role: "Founder, Peak Fitness Co.",
    content: "I had three brand names to register simultaneously. IP Protection Office bundled the filings, saved me money, and still delivered each one ahead of schedule. Highly recommend their services.",
    rating: 5
  },
  {
    id: 7,
    name: "Samantha Cho",
    role: "VP Marketing, GreenLeaf Foods",
    content: "When a competitor tried to register a confusingly similar mark, our case manager acted immediately with a cease and desist. That proactive monitoring justified the investment many times over.",
    rating: 5
  },
  {
    id: 8,
    name: "Jordan McKenzie",
    role: "Entrepreneur, McKenzie Apparel",
    content: "From the initial call to the final certificate, the experience was professional and stress-free. They even helped with our Amazon Brand Registry enrollment afterward. A true one-stop shop.",
    rating: 5
  },
  {
    id: 9,
    name: "Tanya Orozco",
    role: "Founder, Solana Skincare",
    content: "I compared three different services before choosing IP Protection Office. Their transparent pricing, no hidden fees, and genuine client care set them apart from every competitor I evaluated.",
    rating: 5
  },
  {
    id: 10,
    name: "Marcus Webb",
    role: "Operations Director, Atlas Logistics",
    content: "Filing in multiple classes seemed daunting. The team broke down costs, timelines, and risks clearly. We filed in four classes and received approval on all. Outstanding results and communication.",
    rating: 5
  },
  {
    id: 11,
    name: "Linda Park",
    role: "Owner, Serenity Spa & Wellness",
    content: "After a failed DIY attempt, I turned to IP Protection Office. They corrected my previous filing mistakes and successfully got my brand registered. Wish I had come here first.",
    rating: 5
  },
  {
    id: 12,
    name: "Ryan Gallagher",
    role: "Co-Founder, Pixel Forge Studios",
    content: "They protected our game studio's name and logo in record time. Their comprehensive search uncovered a similar mark in a different class we hadn't considered. That foresight saved us from trouble.",
    rating: 5
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Submit Your Details",
    description: "Provide your brand information through our secure intake form. Our specialists review your submission, assess registrability, and identify potential conflicts before moving forward.",
    icon: "Search"
  },
  {
    id: 2,
    title: "Filing & Documentation",
    description: "Our attorneys prepare every required document with precision, select the correct trademark classes, and submit your application directly to the USPTO on your behalf.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Approval & Monitoring",
    description: "Once filed, we track your application through every milestone, respond to office actions promptly, and provide ongoing monitoring to defend your registered mark.",
    icon: "Shield"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Essentials",
    price: "45",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    note: "Govt. filing fee not included"
  },
  {
    id: 2,
    name: "Enhanced",
    price: "149",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter"
    ],
    note: "Govt. filing fee not included"
  },
  {
    id: 3,
    name: "Deluxe",
    price: "299",
    recommended: true,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    note: "Govt. filing fee not included"
  },
  {
    id: 4,
    name: "Platinum",
    price: "349",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "High Approval Rate",
      "Comprehensive Search Report",
      "High Priority Service",
      "Cease & Desist Letter"
    ],
    note: "Govt. filing fee not included"
  }
];

export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    slug: "trademark-registration",
    shortDescription: "Establish exclusive rights to your brand name, logo, or slogan.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Copyright Registration",
    slug: "copyright-registration",
    shortDescription: "Safeguard your original creative works and authored content.",
    icon: "Copyright"
  },
  {
    id: 3,
    title: "Trademark Comprehensive Search",
    slug: "trademark-search",
    shortDescription: "Uncover potential conflicts before you file your application.",
    icon: "Search"
  },
  {
    id: 4,
    title: "Company Formation",
    slug: "company-formation",
    shortDescription: "Set up the right legal entity structure for your venture.",
    icon: "Building2"
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    slug: "amazon-brand-registry",
    shortDescription: "Enroll and protect your brand across the Amazon marketplace.",
    icon: "Package"
  }
];

export const countryCodes = [
  { code: "+1", country: "USA/Canada" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+86", country: "China" },
  { code: "+81", country: "Japan" },
  { code: "+55", country: "Brazil" },
  { code: "+52", country: "Mexico" }
];
